{
  "page": {
    "title": "Khóa API",
    "subtitle": "Quản lý khóa cho Partner Order API"
  },
  "section": {
    "aria": "Khóa Partner API",
    "title": "Khóa API",
    "subtitle": "Tạo và quản lý khóa cho Partner Order API. Chuỗi bí mật chỉ hiển thị một lần."
  },
  "table": {
    "key": "Khóa",
    "label": "Nhãn",
    "status": "Trạng thái",
    "lastUsed": "Lần dùng gần nhất",
    "usage": "Lượt dùng (yêu cầu / lỗi / đơn)",
    "actions": "Thao tác",
    "neverUsed": "chưa dùng lần nào",
    "noActions": "—",
    "revokeOrphanHint": "Khóa này chưa được dùng lần nào — hãy thu hồi nếu chuỗi bí mật đã bị mất."
  },
  "status": {
    "active": "Đang hoạt động",
    "revoked": "Đã thu hồi"
  },
  "empty": {
    "title": "Chưa có khóa API nào",
    "subtitle": "Tạo một khóa để bắt đầu dùng Partner Order API từ hệ thống của bạn.",
    "cta": "Tạo khóa API đầu tiên của bạn"
  },
  "create": {
    "aria": "Tạo khóa API",
    "title": "Tạo khóa API",
    "subtitle": "Đặt nhãn cho khóa để bạn dễ nhận ra sau này.",
    "labelField": "Nhãn",
    "labelPlaceholder": "ví dụ: Production",
    "labelRequired": "Nhập nhãn",
    "copied": "Đã sao chép",
    "copyFailed": "Hãy tự sao chép khóa"
  },
  "reveal": {
    "title": "Đã tạo khóa API",
    "subtitle": "Hãy sao chép chuỗi bí mật ngay bây giờ. Vì lý do bảo mật, khóa sẽ không hiển thị lại.",
    "warning": "Đây là lần duy nhất khóa đầy đủ được hiển thị. Hãy lưu ở nơi an toàn — bạn sẽ không thể xem lại.",
    "secretLabel": "Khóa API của bạn",
    "copyAria": "Sao chép khóa API",
    "done": "Tôi đã lưu khóa"
  },
  "revoke": {
    "aria": "Thu hồi khóa API",
    "title": "Thu hồi khóa API này?",
    "body": "Khóa sẽ ngừng hoạt động ngay lập tức và không thể khôi phục. Mọi tích hợp đang dùng nó sẽ bắt đầu lỗi.",
    "confirmTitle": "Xác nhận thu hồi",
    "confirmBody": "Thao tác này là vĩnh viễn. Bạn sẽ cần tạo khóa mới để kết nối lại.",
    "success": "Đã thu hồi khóa API",
    "error": "Không thể thu hồi khóa"
  },
  "actions": {
    "create": "Tạo khóa API",
    "cancel": "Hủy",
    "continue": "Tiếp tục",
    "revoke": "Thu hồi",
    "retry": "Thử lại"
  },
  "errors": {
    "loadFailed": "Không thể tải danh sách khóa API của bạn.",
    "network": "Lỗi mạng - hãy kiểm tra kết nối"
  }
}
